var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtpEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7351 15.96L24.6367 24.9997L33.7351 34.0395C33.8996 33.6958 33.9994 33.3157 33.9994 32.9099V17.0896C33.9994 16.6837 33.8996 16.3037 33.7351 15.96Z",
    fill: "#1A427D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3621 14.4531H6.63549C6.22961 14.4531 5.84963 14.5529 5.50586 14.7174L17.1346 26.2875C18.1628 27.3157 19.8348 27.3157 20.863 26.2875L32.4917 14.7174C32.1479 14.5529 31.7679 14.4531 31.3621 14.4531Z",
    fill: "#1A427D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26426 15.9602C4.09979 16.304 4 16.684 4 17.0898V32.9101C4 33.316 4.09979 33.6961 4.26426 34.0398L13.3626 25L4.26426 15.9602Z",
    fill: "#1A427D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3933 26.2427L22.1058 27.5302C20.3926 29.2434 17.6049 29.2434 15.8917 27.5302L14.6042 26.2427L5.50586 35.2825C5.84963 35.4469 6.22961 35.5467 6.63549 35.5467H31.3621C31.7679 35.5467 32.1479 35.4469 32.4917 35.2825L23.3933 26.2427Z",
    fill: "#1A427D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.99257V9.00857C9 10.0726 9.912 10.9846 10.976 10.9846H26.632C27.696 10.9846 28.608 10.0726 28.608 9.00857V3.99257C28.608 2.92857 27.696 2.01657 26.632 2.01657H10.976C9.76 1.86457 9 2.77657 9 3.99257ZM24.048 4.90457C24.808 4.90457 25.568 5.51257 25.568 6.42457C25.568 7.18457 24.808 7.94457 24.048 7.94457C23.136 7.94457 22.528 7.18457 22.528 6.42457C22.528 5.66457 23.136 4.90457 24.048 4.90457ZM18.728 4.90457C19.64 4.90457 20.248 5.51257 20.248 6.42457C20.248 7.18457 19.64 7.94457 18.728 7.94457C17.968 7.94457 17.208 7.18457 17.208 6.42457C17.208 5.66457 17.968 4.90457 18.728 4.90457ZM13.56 4.90457C14.32 4.90457 15.08 5.51257 15.08 6.42457C15.08 7.18457 14.32 7.94457 13.56 7.94457C12.8 7.94457 12.04 7.18457 12.04 6.42457C12.04 5.66457 12.648 4.90457 13.56 4.90457Z",
    fill: "#1A427D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpEmail);
export default __webpack_public_path__ + "static/media/otp-email.43ce2e271025c3b03bbf74bd271b6fee.svg";
export { ForwardRef as ReactComponent };